<template>
  <div class="text-center" colspan="6">
    <div
      :class="{ 'mt-4 d-inline-block section-loading': loading }"
      style="height: 20px; width: 30px"
    ></div>
    <h3 class="mb-3">{{ message }}</h3>
  </div>
</template>
<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      required: true
    }
  }
};
</script>
